"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/zh_CN");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "\u66FF\u4EE3\u6587\u672C\uFF1A"
  },
  announcement_list_da155734: {
    message: "\u516C\u544A\u5217\u8868"
  },
  announcements_a4b8ed4a: {
    message: "\u516C\u544A"
  },
  assignments_1e02582c: {
    message: "\u4F5C\u4E1A"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "\u80CC\u666F\u989C\u8272\uFF0C\u6309\u4E0B\u5373\u53EF\u9009\u62E9"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "\u53D6\u6D88\u6587\u4EF6\u4E0A\u4F20"
  },
  cancel_image_upload_2c771950: {
    message: "\u53D6\u6D88\u56FE\u7247\u4E0A\u4F20"
  },
  cc_attribution_f6de631f: {
    message: "CC \u7F72\u540D"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "CC \u7F72\u540D\u3001\u7981\u6B62\u6539\u5199"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "CC \u7F72\u540D\u3001\u975E\u5546\u4E1A"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "CC \u7F72\u540D\u3001\u975E\u5546\u4E1A\u3001\u7981\u6B62\u6539\u5199"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "CC \u7F72\u540D\u3001\u975E\u5546\u4E1A\u3001\u76F8\u540C\u65B9\u5F0F\u5171\u4EAB"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "CC \u7F72\u540D\u3001\u76F8\u540C\u65B9\u5F0F\u5171\u4EAB"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "\u68C0\u67E5\u56FE\u7247\u662F\u5426\u4E3A\u88C5\u9970\u56FE\u7247"
  },
  choose_usage_rights_33683854: {
    message: "\u9009\u62E9\u4F7F\u7528\u6743\u9650..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "\u5355\u51FB\u4EFB\u4F55\u6587\u4EF6\u4EE5\u63D2\u5165\u8BE5\u6587\u4EF6\u7684\u4E0B\u8F7D\u94FE\u63A5\u3002"
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "\u5355\u51FB\u4EFB\u4F55\u56FE\u7247\u4EE5\u5728\u8BE5\u9875\u9762\u4E2D\u5D4C\u5165\u56FE\u7247\u3002"
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "\u5355\u51FB\u4EFB\u4F55\u9875\u9762\u4EE5\u63D2\u5165\u6307\u5411\u8BE5\u9875\u9762\u7684\u94FE\u63A5\u3002"
  },
  click_to_embed_image_33107dd8: {
    message: "\u5355\u51FB\u4EE5\u5D4C\u5165\u56FE\u7247"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "\u5355\u51FB\u4EE5\u5D4C\u5165{ imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "\u5355\u51FB\u4EE5\u63D2\u5165\u6307\u5411\u7F16\u8F91\u5668\u7684\u94FE\u63A5\u3002"
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "\u5355\u51FB\u4EE5\u63D2\u5165\u6307\u5411\u8BE5\u9879\u76EE\u7684\u94FE\u63A5\u3002"
  },
  close_flickr_form_b32e600a: {
    message: "\u5173\u95ED Flickr \u7A97\u4F53"
  },
  collaborations_5c56c15f: {
    message: "\u534F\u4F5C"
  },
  copyright_holder_66ee111: {
    message: "\u7248\u6743\u6301\u6709\u8005\uFF1A"
  },
  course_navigation_dd035109: {
    message: "\u8BFE\u7A0B\u5BFC\u822A"
  },
  creative_commons_license_725584ae: {
    message: "Creative Commons \u8BB8\u53EF\u8BC1\uFF1A"
  },
  decorative_image_fde98579: {
    message: "\u88C5\u9970\u56FE\u7247"
  },
  discussions_a5f96392: {
    message: "\u8BA8\u8BBA"
  },
  discussions_index_6c36ced: {
    message: "\u8BA8\u8BBA\u7D22\u5F15"
  },
  embed_image_1080badc: {
    message: "\u5D4C\u5165\u56FE\u7247"
  },
  enter_search_terms_e397b1f0: {
    message: "\u641C\u7D22\u641C\u7D22\u6761\u4EF6"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "\u4E3A\u6B64\u56FE\u7247\u8F93\u5165\u66FF\u4EE3\u6587\u672C"
  },
  file_upload_form_4aaad554: {
    message: "\u6587\u4EF6\u4E0A\u4F20\u7A97\u4F53"
  },
  files_c300e900: {
    message: "\u6587\u4EF6"
  },
  files_index_af7c662b: {
    message: "\u6587\u4EF6\u7D22\u5F15"
  },
  folder_705fd2d7: {
    message: "\u6587\u4EF6\u5939"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "\u5B57\u4F53\u5927\u5C0F\uFF0C\u6309\u4E0B\u5373\u53EF\u9009\u62E9"
  },
  formatting_press_down_to_select_df728c30: {
    message: "\u683C\u5F0F\uFF0C\u6309\u4E0B\u5373\u53EF\u9009\u62E9"
  },
  grades_a61eba0a: {
    message: "\u8BC4\u5206"
  },
  group_navigation_99f191a: {
    message: "\u5C0F\u7EC4\u5BFC\u822A"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "\u6211\u5DF2\u83B7\u5F97\u4F7F\u7528\u6B64\u6587\u4EF6\u7684\u6743\u9650\u3002"
  },
  i_hold_the_copyright_71ee91b1: {
    message: "\u6211\u6301\u6709\u7248\u6743"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "\u5982\u679C\u60A8\u73B0\u5728\u4E0D\u9009\u62E9\u4F7F\u7528\u6743\u9650\uFF0C\u8BE5\u6587\u4EF6\u5728\u4E0A\u4F20\u540E\u4E0D\u4F1A\u88AB\u53D1\u5E03\u3002"
  },
  image_upload_form_7b74079a: {
    message: "\u56FE\u7247\u4E0A\u4F20\u7A97\u4F53"
  },
  images_7ce26570: {
    message: "\u56FE\u50CF"
  },
  insert_equella_links_49a8dacd: {
    message: "\u63D2\u5165 Equella \u94FE\u63A5"
  },
  insert_link_6dc23cae: {
    message: "\u63D2\u5165\u94FE\u63A5"
  },
  insert_math_equation_57c6e767: {
    message: "\u63D2\u5165\u6570\u5B66\u516C\u5F0F"
  },
  link_7262adec: {
    message: "\u94FE\u63A5"
  },
  link_to_a_new_page_6c4ad034: {
    message: "\u94FE\u63A5\u81F3\u65B0\u9875\u9762"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "\u94FE\u63A5\u81F3\u8BFE\u7A0B\u4E2D\u7684\u5176\u5B83\u5185\u5BB9\u3002"
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "\u94FE\u63A5\u81F3\u5C0F\u7EC4\u4E2D\u7684\u5176\u5B83\u5185\u5BB9\u3002"
  },
  link_to_url_52dd935c: {
    message: "URL \u94FE\u63A5"
  },
  links_14b70841: {
    message: "\u94FE\u63A5"
  },
  load_more_results_460f49a9: {
    message: "\u52A0\u8F7D\u66F4\u591A\u7ED3\u679C"
  },
  loading_25990131: {
    message: "\u52A0\u8F7D\u4E2D\u2026\u2026"
  },
  loading_failed_b3524381: {
    message: "\u52A0\u8F7D\u5931\u8D25\u2026\u2026"
  },
  loading_folders_8d4d5d5a: {
    message: "\u6B63\u5728\u52A0\u8F7D\u6587\u4EF6\u5939..."
  },
  modules_c4325335: {
    message: "\u5355\u5143"
  },
  no_results_940393cf: {
    message: "\u65E0\u7ED3\u679C\u3002"
  },
  pages_e5414c2c: {
    message: "\u9875\u9762"
  },
  people_b4ebb13c: {
    message: "\u4EBA\u5458"
  },
  quizzes_7e598f57: {
    message: "\u6D4B\u9A8C"
  },
  record_upload_media_5fdce166: {
    message: "\u8BB0\u5F55/\u4E0A\u4F20\u5A92\u4F53"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "\u5BCC\u6587\u672C\u533A\u57DF\u3002\u6309 ALT+F8 \u83B7\u53D6\u5E2E\u52A9"
  },
  search_280d00bd: {
    message: "\u641C\u7D22"
  },
  search_flickr_6884b518: {
    message: "\u641C\u7D22 Flickr"
  },
  select_a_file_53ba40ac: {
    message: "\u9009\u62E9\u4E00\u4E2A\u6587\u4EF6"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "\u9009\u62E9\u60A8\u7684\u6587\u4EF6\u8981\u4E0A\u4F20\u81F3\u5176\u4E2D\u7684\u6587\u4EF6\u5939"
  },
  syllabus_f191f65b: {
    message: "\u6559\u5B66\u5927\u7EB2"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "\u6587\u672C\u989C\u8272\uFF0C\u6309\u4E0B\u5373\u53EF\u9009\u62E9"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "\u6750\u6599\u5728\u516C\u5F00\u57DF\u4E2D"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "\u6750\u6599\u5DF2\u6839\u636E Creative Commons \u8BB8\u53EF"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "\u6750\u6599\u53D7\u516C\u6B63\u4F7F\u7528\u4F8B\u5916\u7684\u7EA6\u675F"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "\u6B64\u4E0A\u4F20\u6587\u4EF6\u8D85\u51FA\u4E86\u6587\u4EF6\u5B58\u50A8\u9650\u989D\u3002\u8BF7\u4E0E\u60A8\u7684\u7CFB\u7EDF\u7BA1\u7406\u5458\u6C9F\u901A\u3002"
  },
  upload_8b403d05: {
    message: "\u4E0A\u4F20"
  },
  upload_a_new_file_96e6d4ff: {
    message: "\u4E0A\u4F20\u65B0\u6587\u4EF6"
  },
  upload_a_new_image_890df275: {
    message: "\u4E0A\u4F20\u65B0\u56FE\u7247"
  },
  usage_right_ff96f3e2: {
    message: "\u4F7F\u7528\u6743\u9650\uFF1A"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "\u60A8\u60F3\u8981\u65B0\u9875\u9762\u53EB\u4EC0\u4E48\u540D\u5B57?"
  },
  wiki_home_9cd54d0: {
    message: "\u7EF4\u57FA\u4E3B\u9875"
  }
};

_formatMessage.default.addLocale({
  "zh-Hans": locale
});